module.exports = __webpack_public_path__ + "static/media/share_link.c6a697ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gifshop/share_link.jpg
// module id = 240
// module chunks = 0